export default __webpack_public_path__ + "static/media/details.6457831e.svg";